var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PartnerWelcome"},[_c('h1',{staticClass:"text-center"},[_vm._v("Látogatói regisztráció")]),_vm._v(" "),_c('VisitorRegisterAction')],1)}
var staticRenderFns = []

export { render, staticRenderFns }